// import { Link } from "@quintype/components";
import React, { useState } from "react";
import { FaClipboardList, FaTimes } from "react-icons/fa";

// import { useSelector } from "react-redux";
import { Link } from "@quintype/components";
import "./mob-tmr-banner.m.css";

const MobTMRBanner = () => {
  const [toShowPopup, setToShowPopup] = useState(true);
  const [isHindi, setIsHindi] = useState(  
    global.location.host.includes("hindi")
  );
  // const [text, setText] = useState(null);

  // const text =
  //   "NL and IFF are independent news organisations funded by readers and informed citizens. FoE Con is an effort to enable conversations around the media and regulatory framework in India. Click here to support the forum.";
  // const link = "/valentine-mystery-box";
  // const [link, setLink] = useState("/");

  // const { member, fetchSubscription } = useSelector(state => state);

  // useEffect(() => {
  //   if (!member) {
  //     // setText(
  //     //   `Be the Santa for free press. Gift yourself or your friends our Christmas hamper. Buy`
  //     // );
  //     // setLink("/christmas-offer");
  //     setToShowPopup(false);
  //   } else {
  //     if (fetchSubscription.isActive) {
  //       if (fetchSubscription.isRecurring) {
  //         // setText(
  //         //   "Be the Santa for free press. Gift yourself or your friends our Christmas hamper. Buy"
  //         // );
  //         // setLink("/christmas-offer");
  //         setToShowPopup(false);
  //       } else {
  //         setText(
  //           "Flat 20% off and exclusive merch with our annual subscription. Use code FLAT20. Extend your subscription"
  //         );
  //         setLink("/subscription");
  //       }
  //     } else if (fetchSubscription.isExpired) {
  //       setText(
  //         "Last chance: Get flat 20% and free with our annual subscription. Use code LASTCHANCE. Subscribe"
  //       );
  //       setLink("/subscription");
  //     }
  //   }
  // }, [member, fetchSubscription]);

  if (!toShowPopup) {
    return null;
  }
  else if( toShowPopup &&  isHindi){ 
    return (
      <div styleName="wrapper">
        {/* Remove display none to show ticker */}
        <div styleName="row-wrapper">
          {/* <FaClipboardList /> */}
          <p>
            साबित कीजिए कि हिंदी का पाठक और दर्शक भी खबरों के लिए खर्च करता है.
            न्यूज़लॉन्ड्री हिंदी के सब्सक्राइबर बनें और 50% छूट का लाभ उठाएं.
            <Link href="https://hindi.newslaundry.com/subscription">सब्सक्राइब करें</Link>
          </p>
        </div>
        <div styleName="cancel-btn-div">
          <button styleName="cancel-btn" onClick={() => setToShowPopup(false)}>
            <FaTimes />
          </button>
        </div>
      </div>
    )
  } else {
    return null;
  }
};

export { MobTMRBanner };
